module.exports = __webpack_public_path__ + "static/media/pompka_off.60d0a6c1.svg";